/**
 * App configuration.
 *
 * `API_BASE_URL` is prepended to every API path (see api/client.ts). All askk
 * APIs go through the ShareChat gateway, so in production this is
 * `https://apis.sharechat.com` and the feed resolves to
 * `https://apis.sharechat.com/mashvara-service/v1/public/astrology/horoscope/today`.
 *
 * Set per-environment via `REACT_APP_*` (read at BUILD time):
 * - PROD: `.env.production` sets `REACT_APP_API_BASE_URL=https://apis.sharechat.com`.
 * - DEV (`npm start`): set the same in `.env.local` to hit prod directly, or use
 *   `REACT_APP_USE_MOCK=true` for the local mock feed. The default below is ''.
 *
 * We hit the API DIRECTLY (no dev proxy) — it's a DIFFERENT origin from the
 * WebView page, so the request is cross-origin: apis.sharechat.com must CORS
 * allow-list the web origin (and the dev origin for local testing). Page-origin
 * cookies are NOT sent to it — identity rides on the X-SHARECHAT-* headers.
 */
export const API_BASE_URL: string = process.env.REACT_APP_API_BASE_URL ?? ''

/**
 * When true, the horoscope endpoint returns local mock data instead of hitting
 * the network. Lets us build/preview the UI before the backend is ready. Enable
 * by adding `REACT_APP_USE_MOCK=true` to a `.env.local` file (then restart).
 */
export const USE_MOCK: boolean = process.env.REACT_APP_USE_MOCK === 'true'

/** Tenant + locale headers required by the askk APIs. */
export const API_TENANT = 'askk'
export const API_LOCALE_LANGUAGE = 'English'
